// @flow

import { getComponentSettings } from './main';

import { type State } from '../reducers';
import { type State as Pdb } from '../../pdb/types';

type GlobalState = {
  pdb: Pdb,
  componentSettings: State,
};

export type InfoSettings = $PropertyType<State, 'pdb_info'>;
export const getInfoSettings = (state: GlobalState): InfoSettings => {
  const info = getComponentSettings(state).pdb_info;
  if (!info) {
    throw new Error('Missing pdb_info settings in componentSettings store.');
  }
  return info;
};

type BasePriceLabel = $PropertyType<InfoSettings, 'base_price_label'>;
export const getBasePriceLabel = (state: GlobalState): BasePriceLabel => (
  getInfoSettings(state).base_price_label
);

type ContractDurationAbbrv = $PropertyType<InfoSettings, 'contract_duration_abbrv'>;
export const getContractDurationAbbrv = (state: GlobalState): ContractDurationAbbrv => (
  getInfoSettings(state).contract_duration_abbrv
);

type MileageAbbrv = $PropertyType<InfoSettings, 'mileage_abbrv'>;
export const getMileageAbbrv = (state: GlobalState): MileageAbbrv => (
  getInfoSettings(state).mileage_abbrv
);

type YearAbbrv = $PropertyType<InfoSettings, 'year_abbrv'>;
export const getYearAbbrv = (state: GlobalState): YearAbbrv => (
  getInfoSettings(state).year_abbrv
);

type AndAbbrv = $PropertyType<InfoSettings, 'and_abbrv'>;
export const getAndAbbrv = (state: GlobalState): AndAbbrv => (
  getInfoSettings(state).and_abbrv
);

type PerAbbrv = $PropertyType<InfoSettings, 'per_abbrv'>;
export const getPerAbbrv = (state: GlobalState): PerAbbrv => (
  getInfoSettings(state).per_abbrv
);

type RoadtaxNote = $PropertyType<InfoSettings, 'roadtax_note'>;
export const getRoadtaxNote = (state: GlobalState): RoadtaxNote => (
  getInfoSettings(state).roadtax_note
);

type ContractPostfixText = $PropertyType<InfoSettings, 'contract_postfix'>;
export const getContractPostfixText = (state: GlobalState): ContractPostfixText => (
  getInfoSettings(state).contract_postfix
);

type ContractPrefixText = $PropertyType<InfoSettings, 'contract_prefix'>;
export const getContractPrefixText = (state: GlobalState): ContractPrefixText => (
  getInfoSettings(state).contract_prefix
);

type AvailableLabel = $PropertyType<InfoSettings, 'available_label'>;
export const getAvailableLabel = (state: GlobalState): AvailableLabel => (
  getInfoSettings(state).available_label
);

type OccasionLinkTextSingle = $PropertyType<InfoSettings, 'occasion_link_text_single'>;
export const getOccasionLinkTextSingle = (state: GlobalState): OccasionLinkTextSingle => (
  getInfoSettings(state).occasion_link_text_single
);

type OccasionLinkTextPlural = $PropertyType<InfoSettings, 'occasion_link_text_plural'>;
export const getOccasionLinkTextPlural = (state: GlobalState): OccasionLinkTextPlural => (
  getInfoSettings(state).occasion_link_text_plural
);

export default null;
